// extracted by mini-css-extract-plugin
module.exports = {"post":"styles_post__20put","imageWrap":"styles_imageWrap__36P4H"};